import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop } from 'rxjs';
import { NumericConfig } from '../../../lsn-numeric/numeric-config.service';
import { LsnErrorStateMatcher } from '../error-state-matcher';

export const CUSTOM_SELECT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputComponent),
    multi: true
};

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    providers: [CUSTOM_SELECT_CONTROL_VALUE_ACCESSOR]
})
export class InputComponent implements ControlValueAccessor {

    @Input() required = false;
    @Input() floatLabel: string;
    @Input() errorStateMatcher: LsnErrorStateMatcher;
    @Input() config: NumericConfig = {};
    @Input() placeholder: string;
    @Input() suffix: string;
    @Input() disabled = false;
    @Input() autocomplete = 'off';
    @Input() name = '';
    @Input() slim = false;
    @Input() type = 'text';
    @Input() suffixIconClass: string;
    @Input() label: string = '';
    @Input() uppercase: boolean = true;
    @Input() maxLength: number = null;

    // tslint:disable-next-line:no-output-on-prefix
    @Output() onBlur = new EventEmitter();

    value: number = null;

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    constructor() {
    }

    write(input: HTMLInputElement, value: any) {
        if (this.uppercase) {
            const start = input.selectionStart;
            const end = input.selectionEnd;
            setTimeout(() => input.setSelectionRange(start, end));
            value = value.toUpperCase();
        }
        this.writeValue(value);
    }

    writeValue(value: any) {
        this.value = value;
        this.onChangeCallback(value);
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
}
